<template>
  <FsDialog
    v-model="exportProjectPopupShow"
    width="480px"
    title="Export PDF"
    class-name="export_project_popup"
    :close-modal="false"
  >
    <CustomerForm :data="projectDetail" @close="hideDialog" v-if="['PURCHASER', 'EMPLOYEE'].includes(customersType)" />
    <TechnicianForm @close="hideDialog" v-else />
  </FsDialog>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, reactive, ref, watch } from 'vue'
import { FsDialog, FsButton } from 'fs-design'
import CustomerForm from './CustomerForm.vue'
import TechnicianForm from './TechnicianForm.vue'
import { getProjectDetail, getTemplatePopupList } from '@/api/modules/project'
import { useProjectStore } from '@/store/project'
import { useUserStore } from '@/store/user'
import { storeToRefs } from 'pinia'

interface IModal {
  open: boolean
  progress: number
  timer: number | null
}

interface Project {
  id: number
  name: string
  templateId: number
  description: string
  area: string
  createdAt: string
  isShared: 0 | 1
  isCustomized: 0 | 1
  emails: string[]
  createdBy: string
  templateDescription: string
}

const projectStore = useProjectStore()
const userStore = useUserStore()
const { exportProjectId, exportProjectPopupShow } = storeToRefs(projectStore)
const { customersType } = storeToRefs(userStore)

const projectDetail = ref<Project>({
  id: 0,
  name: '',
  templateId: 0,
  description: '',
  area: '',
  createdAt: '',
  isShared: 0,
  isCustomized: 0,
  emails: [],
  createdBy: '',
  templateDescription: '',
})
// const exportLoadingModal = reactive<IModal>({
//   open: false,
//   progress: 0,
//   timer: null,
// })

const handleOk = () => {}

const hideDialog = () => {
  projectStore.hideExportProjectPopup()
}

onMounted(() => {
  console.log('export_export ')
})
onUnmounted(() => {
  //   exportLoadingModal.timer && clearInterval(exportLoadingModal.timer)
})

watch(
  () => exportProjectPopupShow.value,
  async (newValue, oldValue) => {
    if (newValue) {
      try {
        const [projectDetailRes, templateListRes] = await Promise.all([
          getProjectDetail({ id: exportProjectId.value }) as Promise<{ data: Project }>,
          getTemplatePopupList() as Promise<{ data: any }>,
        ])

        projectDetail.value = projectDetailRes.data as Project
        if (projectDetailRes?.data?.templateId) {
          templateListRes?.data[0]?.templateList.forEach((item: any) => {
            if (item.id === projectDetailRes?.data?.templateId) {
              projectDetail.value.templateDescription = item.description
            }
          })
        } else {
          projectDetail.value.templateDescription = ''
        }

        console.log(templateListRes)
      } catch (err) {
        console.error('请求失败:', err)
      }
    }
  }
)
defineExpose({
  hideDialog,
})
</script>

<style lang="scss">
// PS: 因为 Teleport 的缘故，所以需要使用全局样式
.export_project_popup {
  .fs-dialog__content--box {
    display: flex;
    flex-direction: column;
    padding: 0 !important;
  }

  .export-project__title {
    padding-top: 4px;
    margin-bottom: $spacing-base;
    line-height: 22px;
    color: $text-primary;
    font-size: $font-size-base;
    font-weight: $font-weight-bold;
  }

  .export-project__divider {
    width: 100%;
    height: 1px;
    margin: $spacing-large-new 0;
    background-color: $border-color-light;
  }

  .fs-input__wrapper {
    border-color: transparent;
    background-color: #f6f6f8 !important;
    box-shadow: none;
  }

  .fs-upload__box {
    height: 22px !important;
    line-height: 22px !important;
  }

  .fs-upload-box__uploadBtn {
    padding: 0 !important;
    height: 22px !important;
    border: none !important;
    background-color: transparent !important;
  }

  .fs-textarea__wrapper {
    border-color: transparent;
    background-color: #f6f6f8 !important;
    box-shadow: none;
  }

  .fs-textarea__number {
    top: -24px;
    bottom: auto;
    margin-top: 0;
  }
}
</style>

<style lang="scss" scoped></style>
